import React from 'react';
import { Outlet, createBrowserRouter } from 'react-router-dom';
import Home from '../Screens/Home';
import OnBoardingPage from '../Screens/app-user-registration/OnBoardingPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <Home />,
      }
    ],
  },
  {
    path: 'app-user-registration',
    element: <OnBoardingPage />,
  },
]);
